import { CoreError, CoreErrorCause } from '@domain/models/core-error'

export class YouTubeErrorConverter {
  public static domainModel(fromExternalModel: unknown): CoreError {
    if (fromExternalModel instanceof CoreError) {
      return fromExternalModel
    }

    if (!(fromExternalModel instanceof Error)) {
      return new CoreError({
        cause: CoreErrorCause.Unknown,
        context: `An unknown YouTube service error happened: ${String(fromExternalModel)}`,
        underlyingException: fromExternalModel,
      })
    }

    return new CoreError({
      cause: CoreErrorCause.NetworkConnection,
      context: fromExternalModel.message || 'Failed to fetch YouTube feed.',
      underlyingException: fromExternalModel,
    })
  }
}
